// Store imports
import { configureStore } from "@reduxjs/toolkit";
import { persistStore } from "redux-persist";

import testAutomationReducer from "./slices/test-automation/testAutomationSlice";
import { persistConfigGenerator } from "./utils/persistConfigGenerator";
import { persistReducerGenerator } from "./utils/persistReducerGenerator";

const testAutomationPersistConfig = persistConfigGenerator("testAutomation");
const testAutomationPersistedReducer = persistReducerGenerator(testAutomationPersistConfig, testAutomationReducer);

const storeReducers = {
  testAutomation: testAutomationPersistedReducer
}

// Initializing store
export const store = configureStore({
  reducer: storeReducers,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [
          "persist/PERSIST",
          "persist/REHYDRATE",
          "persist/REGISTER",
          "persist/PURGE",
          "persist/FLUSH",
          "persist/PAUSE",
        ],
        ignoredPaths: ["_persist"],
      },
    }),
});

export const persistor = persistStore(store);